import React, {useState, useEffect} from 'react';
import './header.scss';
import { NavLink, useLocation , Link } from 'react-router-dom';
import { Nav, Navbar, Container, Button  } from 'react-bootstrap';
import {IconSearch, Logo , Account , Hamburger} from '../../../icon/icons';
const Header = () => {
  useEffect(() => {
    let lastScrollTop = 0;

    const handleScroll = () => {
      const currentScroll = window.scrollY;
      const header = document.getElementById("header");
      const navbar = document.getElementById("Navbar");

      if (currentScroll > lastScrollTop) {
        // Scrolling down
        header.style.top = "-45px";
        navbar.style.top = "0px"; 
      } else {
        // Scrolling up
        header.style.top = "0px";
        navbar.style.top = "45px";
      }

      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const location = useLocation();

  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const closeSidebar = () => {
    setIsOpen(false);
  };

  return (
    <>
      {/* desktop header */}
      <header className='header-wrapper'>
        <Navbar collapseOnSelect expand="lg" id='header' className="">
          <Container>
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="ms-auto">
                <NavLink to="/aboutus">About us</NavLink>
                <NavLink href="#/">Careers</NavLink>
                <NavLink to="/contact-us">Contact us</NavLink>
                <NavLink to="/for-agents-and-brokers">For agents and brokers</NavLink>
                <NavLink to="/customers">For customers</NavLink>
                <NavLink to="/quickpay">Make a payment</NavLink>
              </Nav>
              <Nav>
                <Button className="search-btn"><IconSearch/></Button>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </header>
      {/* desktop navbar */}
      <nav className='navbar-wrapper sticky-navbar'>
        <Navbar collapseOnSelect expand="lg" className="" id='Navbar'>
          <Container>
            <Navbar.Brand as={Link} to="/"><Logo/></Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="me-auto">
                <NavLink to="/whoweserve" className={location.pathname === '/whoweserve' ? 'active' : ''}>Who we serve</NavLink>
                <NavLink to="/what-we-offer" className={location.pathname === '/what-we-offer' ? 'active' : ''}>What we offer</NavLink>   
                <NavLink to="/whychoosesentry" className={location.pathname === '/whychoosesentry' ? 'active' : ''}>Why choose Sentry</NavLink>
                <NavLink to="/claims" className={location.pathname === '/claims' ? 'active' : ''}>Claims</NavLink>
              </Nav>
              <Nav className='Login-btn'>
                <NavLink to="/login"><Account/> Log in</NavLink>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </nav>
      {/* mobile sidebar */}
      <div className='mobile-header-wrapper'>
        <Navbar collapseOnSelect expand="lg" className="mobile-navbar">
            <Navbar.Brand as={Link} to="/"><Logo /></Navbar.Brand>
            <div className='right-column'>
              <IconSearch/>
              <NavLink to='/login'><Account/></NavLink>
              <button onClick={toggleSidebar} className='hamburger'><Hamburger/></button>
            </div>
        </Navbar>
        <div className={`nav-content-collapse ${isOpen ? "open" : ""}`}>
          <div className='top-heading-wrapper'>
            <Logo />
            <button onClick={closeSidebar} className='cancel-btn'><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"></path></svg></button>
          </div>
          <Nav className="top-nav">
            <NavLink to="/whoweserve" className={location.pathname === '/whoweserve' ? 'active' : ''}>Who we serve</NavLink>
            <NavLink to="/what-we-offer" className={location.pathname === '/what-we-offer' ? 'active' : ''}>What we offer</NavLink>
            <NavLink to="/whychoosesentry" className={location.pathname === '/whychoosesentry' ? 'active' : ''}>Why choose Sentry</NavLink>
            <NavLink to="/claims" className={location.pathname === '/claims' ? 'active' : ''}>Claims</NavLink>
          </Nav>
          <Nav className='Login-btn'>
            <NavLink to="/login">Log in <Account /></NavLink>
          </Nav>
          <Nav className="bottom-nav">
            <NavLink to="/aboutus">About us</NavLink>
            <NavLink to="#/">Careers</NavLink>
            <NavLink to="/contact-us">Contact us</NavLink>
            <NavLink to="/for-agents-and-brokers">For agents and brokers</NavLink>
            <NavLink to="/customers">For customers</NavLink>
            <NavLink to="/quickpay">Make a payment</NavLink>
          </Nav>
        </div>
        {/* Backdrop */}
        {isOpen && <div onClick={closeSidebar} className="backdrop"></div>}
      </div>
      <div id="header-top-height" className="header-top-height"></div>
    </>
  )
}

export default Header